import { render } from "./moveBuild.vue?vue&type=template&id=3e222890&scoped=true&ts=true"
import script from "./moveBuild.vue?vue&type=script&lang=ts"
export * from "./moveBuild.vue?vue&type=script&lang=ts"

import "./moveBuild.vue?vue&type=style&index=0&id=3e222890&lang=less&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e222890"]])

export default __exports__